/* Half Point Racing — scroll reveal + cursor-reactive header */
(function () {
  var d = document.documentElement;
  d.classList.add('hp-anim');

  /* --- cursor position → CSS vars (--hp-mx / --hp-my) --- */
  function bindPointer(el) {
    if (el.dataset.hpTrack) return;
    el.dataset.hpTrack = '1';
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      el.style.setProperty('--hp-mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
      el.style.setProperty('--hp-my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
    });
  }

  function init() {
    // cursor-reactive header icons + nav links
    document
      .querySelectorAll('#header-component .header-actions__action, #header-component .menu-list__link')
      .forEach(bindPointer);

    // auto-tag product & collection cards with staggered delays
    ['.product-card', '.collection-card'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        if (!el.hasAttribute('data-hp-reveal')) {
          el.setAttribute('data-hp-reveal', '');
          el.style.setProperty('--hp-delay', (Math.min(i % 8, 5) * 0.07) + 's');
        }
      });
    });

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-hp-reveal]').forEach(function (el) { el.classList.add('hp-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hp-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-hp-reveal]').forEach(function (el) {
      if (el.classList.contains('hp-in')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('hp-in'); // already on screen: show immediately
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-run after section re-renders (theme editor / dynamic pagination)
  document.addEventListener('shopify:section:load', init);
})();
